/**
 * Created by weid on 2017/6/21.
 */
import typesGenerator from 'typesGenerator';

export default typesGenerator(
    'root',
    `

SET_USER_INFO

`
);



// WEBPACK FOOTER //
// ./src/rootRedux/constants/types.js